// Comprehensive Building Materials Database
// DEMO MATERIALS (Square Feet to Pounds) - Demolished/Broken Up Weight
// Note: Weights include demolition factor (typically 1.25-1.4x original weight due to debris, fasteners, broken pieces)
// Default disposal costs are typical dumpster/landfill rates
export const materialDatabase = [
  // === WALLS ===
  {
    name: '1/4" Drywall (Sheetrock)',
    category: 'Walls',
    weightPerSqFt: 1.7,
    defaultCostPerTon: 65,
    description: 'Demolished thin gypsum wallboard (includes debris)'
  },
  {
    name: '3/8" Drywall (Sheetrock)',
    category: 'Walls',
    weightPerSqFt: 2.5,
    defaultCostPerTon: 65,
    description: 'Demolished light-duty gypsum wallboard'
  },
  {
    name: '1/2" Drywall (Sheetrock)',
    category: 'Walls',
    weightPerSqFt: 3.2,
    defaultCostPerTon: 65,
    description: 'Demolished standard gypsum wallboard with fasteners'
  },
  {
    name: '5/8" Drywall (Sheetrock)',
    category: 'Walls',
    weightPerSqFt: 4.0,
    defaultCostPerTon: 65,
    description: 'Demolished fire-rated wallboard with debris'
  },
  {
    name: '3/4" Drywall (Sheetrock)',
    category: 'Walls',
    weightPerSqFt: 4.9,
    defaultCostPerTon: 65,
    description: 'Demolished heavy-duty wallboard'
  },
  {
    name: 'Standard Wood Framed Wall (2x3)',
    category: 'Walls',
    weightPerSqFt: 6.0,
    defaultCostPerTon: 75,
    description: 'Demolished wood stud framing with drywall and nails'
  },
  {
    name: 'Standard Wood Framed Wall (2x4)',
    category: 'Walls',
    weightPerSqFt: 6.8,
    defaultCostPerTon: 75,
    description: 'Demolished wood stud framing with drywall and fasteners'
  },
  {
    name: 'Standard Wood Framed Wall (2x6)',
    category: 'Walls',
    weightPerSqFt: 9.4,
    defaultCostPerTon: 75,
    description: 'Heavier wood stud framing with drywall on both sides'
  },
  {
    name: 'Standard Wood Framed Wall (2x8)',
    category: 'Walls',
    weightPerSqFt: 9.1,
    defaultCostPerTon: 75,
    description: 'Extra thick wood stud framing'
  },
  
  // === SIDING ===
  {
    name: 'Vinyl Siding',
    category: 'Siding',
    weightPerSqFt: 1.6,
    defaultCostPerTon: 55,
    description: 'Lightweight vinyl exterior siding'
  },
  {
    name: 'Aluminum Siding',
    category: 'Siding',
    weightPerSqFt: 2.0,
    defaultCostPerTon: 45,
    description: 'Aluminum exterior siding'
  },
  {
    name: 'Wood Clapboard Siding (1/2")',
    category: 'Siding',
    weightPerSqFt: 3.2,
    defaultCostPerTon: 75,
    description: 'Traditional wood clapboard siding'
  },
  {
    name: 'Wood Clapboard Siding (3/4")',
    category: 'Siding',
    weightPerSqFt: 4.5,
    defaultCostPerTon: 65,
    description: 'Thick wood clapboard siding'
  },
  {
    name: 'Cedar Shake Siding',
    category: 'Siding',
    weightPerSqFt: 3.9,
    defaultCostPerTon: 65,
    description: 'Natural cedar shake exterior siding'
  },
  {
    name: 'Fiber Cement Siding (5/16")',
    category: 'Siding',
    weightPerSqFt: 3.0,
    defaultCostPerTon: 65,
    description: 'Durable fiber cement siding (e.g., Hardie Board)'
  },
  {
    name: 'Fiber Cement Siding (1/2")',
    category: 'Siding',
    weightPerSqFt: 4.5,
    defaultCostPerTon: 65,
    description: 'Thick fiber cement siding'
  },
  {
    name: 'Stucco (1" Traditional)',
    category: 'Siding',
    weightPerSqFt: 13.0,
    defaultCostPerTon: 65,
    description: 'Traditional 3-coat stucco system'
  },
  {
    name: 'Stucco (EIFS Synthetic)',
    category: 'Siding',
    weightPerSqFt: 4.5,
    defaultCostPerTon: 65,
    description: 'Exterior Insulation Finishing System'
  },
  {
    name: 'Brick Veneer (4")',
    category: 'Siding',
    weightPerSqFt: 52.0,
    defaultCostPerTon: 65,
    description: 'Thin brick veneer exterior'
  },
  {
    name: 'Stone Veneer (Cultured)',
    category: 'Siding',
    weightPerSqFt: 15.6,
    defaultCostPerTon: 65,
    description: 'Manufactured stone veneer'
  },
  {
    name: 'Natural Stone Veneer',
    category: 'Siding',
    weightPerSqFt: 19.5,
    defaultCostPerTon: 65,
    description: 'Natural stone exterior veneer'
  },
  {
    name: 'Metal Panel Siding',
    category: 'Siding',
    weightPerSqFt: 2.6,
    defaultCostPerTon: 65,
    description: 'Corrugated or standing seam metal siding'
  },
  
  // === MASONRY ===
  {
    name: '4" Concrete Cinder Block',
    category: 'Masonry',
    weightPerSqFt: 39.0,
    defaultCostPerTon: 55,
    description: 'Lightweight 4-inch concrete masonry unit'
  },
  {
    name: '6" Concrete Cinder Block',
    category: 'Masonry',
    weightPerSqFt: 54.6,
    defaultCostPerTon: 55,
    description: 'Medium 6-inch concrete masonry unit'
  },
  {
    name: '8" Concrete Cinder Block',
    category: 'Masonry',
    weightPerSqFt: 71.5,
    defaultCostPerTon: 55,
    description: 'Standard 8-inch concrete masonry unit (CMU)'
  },
  {
    name: '10" Concrete Cinder Block',
    category: 'Masonry',
    weightPerSqFt: 91.0,
    defaultCostPerTon: 55,
    description: 'Heavy 10-inch concrete masonry unit'
  },
  {
    name: '12" Concrete Cinder Block',
    category: 'Masonry',
    weightPerSqFt: 110.5,
    defaultCostPerTon: 55,
    description: 'Extra heavy 12-inch concrete masonry unit'
  },
  {
    name: 'Brick Wall (4" Single Wythe)',
    category: 'Masonry',
    weightPerSqFt: 52.0,
    defaultCostPerTon: 55,
    description: 'Single layer of standard brick'
  },
  {
    name: 'Brick Wall (8" Double Wythe)',
    category: 'Masonry',
    weightPerSqFt: 104.0,
    defaultCostPerTon: 55,
    description: 'Double layer of brick with mortar'
  },
  {
    name: 'Brick Wall (12" Triple Wythe)',
    category: 'Masonry',
    weightPerSqFt: 156.0,
    defaultCostPerTon: 55,
    description: 'Triple layer of brick'
  },
  
  // === FLOORING / CONCRETE ===
  {
    name: '2" Concrete Slab',
    category: 'Flooring',
    weightPerSqFt: 32.5,
    defaultCostPerTon: 65,
    description: 'Thin concrete slab'
  },
  {
    name: '3" Concrete Slab',
    category: 'Flooring',
    weightPerSqFt: 48.8,
    defaultCostPerTon: 65,
    description: 'Light concrete slab'
  },
  {
    name: '4" Concrete Slab',
    category: 'Flooring',
    weightPerSqFt: 65.0,
    defaultCostPerTon: 65,
    description: 'Standard concrete slab, 4 inches thick'
  },
  {
    name: '5" Concrete Slab',
    category: 'Flooring',
    weightPerSqFt: 81.2,
    defaultCostPerTon: 65,
    description: 'Medium concrete slab'
  },
  {
    name: '6" Concrete Slab',
    category: 'Flooring',
    weightPerSqFt: 97.5,
    defaultCostPerTon: 65,
    description: 'Thicker concrete slab, 6 inches thick'
  },
  {
    name: '8" Concrete Slab',
    category: 'Flooring',
    weightPerSqFt: 130.0,
    defaultCostPerTon: 65,
    description: 'Heavy-duty concrete slab, 8 inches thick'
  },
  {
    name: '10" Concrete Slab',
    category: 'Flooring',
    weightPerSqFt: 162.5,
    defaultCostPerTon: 65,
    description: 'Extra thick concrete slab'
  },
  {
    name: '12" Concrete Slab',
    category: 'Flooring',
    weightPerSqFt: 195.0,
    defaultCostPerTon: 65,
    description: 'Very heavy concrete slab'
  },
  {
    name: '1/2" Hardwood Flooring',
    category: 'Flooring',
    weightPerSqFt: 2.6,
    defaultCostPerTon: 65,
    description: 'Thin solid hardwood flooring'
  },
  {
    name: '3/4" Hardwood Flooring',
    category: 'Flooring',
    weightPerSqFt: 3.2,
    defaultCostPerTon: 65,
    description: 'Standard solid hardwood flooring'
  },
  {
    name: '1" Hardwood Flooring',
    category: 'Flooring',
    weightPerSqFt: 3.9,
    defaultCostPerTon: 65,
    description: 'Thick solid hardwood flooring'
  },
  {
    name: '1/4" Ceramic Tile',
    category: 'Flooring',
    weightPerSqFt: 3.2,
    defaultCostPerTon: 65,
    description: 'Standard ceramic floor tile'
  },
  {
    name: '3/8" Porcelain Tile',
    category: 'Flooring',
    weightPerSqFt: 5.2,
    defaultCostPerTon: 65,
    description: 'Dense porcelain floor tile'
  },
  {
    name: '1/2" Porcelain Tile',
    category: 'Flooring',
    weightPerSqFt: 7.2,
    defaultCostPerTon: 65,
    description: 'Thick porcelain floor tile'
  },
  {
    name: '3/8" Marble/Granite Tile',
    category: 'Flooring',
    weightPerSqFt: 6.5,
    defaultCostPerTon: 65,
    description: 'Natural stone flooring'
  },
  {
    name: '1/2" Marble/Granite Tile',
    category: 'Flooring',
    weightPerSqFt: 8.5,
    defaultCostPerTon: 65,
    description: 'Thick natural stone flooring'
  },
  {
    name: 'Vinyl/LVT Flooring',
    category: 'Flooring',
    weightPerSqFt: 2.0,
    defaultCostPerTon: 65,
    description: 'Luxury vinyl tile or plank flooring'
  },
  {
    name: 'Laminate Flooring',
    category: 'Flooring',
    weightPerSqFt: 2.6,
    defaultCostPerTon: 65,
    description: 'Composite laminate flooring'
  },
  
  // === ROOFING MATERIALS ===
  {
    name: 'Asphalt Shingles (3-Tab)',
    category: 'Roofing',
    weightPerSqFt: 3.0,
    defaultCostPerTon: 65,
    description: 'Standard 3-tab asphalt shingles'
  },
  {
    name: 'Asphalt Shingles (Architectural)',
    category: 'Roofing',
    weightPerSqFt: 4.5,
    defaultCostPerTon: 65,
    description: 'Thicker dimensional asphalt shingles'
  },
  {
    name: 'Asphalt Shingles (Luxury)',
    category: 'Roofing',
    weightPerSqFt: 5.9,
    defaultCostPerTon: 65,
    description: 'Premium heavy asphalt shingles'
  },
  {
    name: 'Clay Tile Roofing (Standard)',
    category: 'Roofing',
    weightPerSqFt: 13.0,
    defaultCostPerTon: 65,
    description: 'Traditional clay roofing tiles'
  },
  {
    name: 'Clay Tile Roofing (Heavy)',
    category: 'Roofing',
    weightPerSqFt: 15.6,
    defaultCostPerTon: 65,
    description: 'Heavy-duty clay roofing tiles'
  },
  {
    name: 'Concrete Tile Roofing (Standard)',
    category: 'Roofing',
    weightPerSqFt: 12.3,
    defaultCostPerTon: 65,
    description: 'Standard concrete roofing tiles'
  },
  {
    name: 'Concrete Tile Roofing (Heavy)',
    category: 'Roofing',
    weightPerSqFt: 15.0,
    defaultCostPerTon: 65,
    description: 'Heavy concrete roofing tiles'
  },
  {
    name: 'Metal Roofing (Aluminum)',
    category: 'Roofing',
    weightPerSqFt: 1.0,
    defaultCostPerTon: 65,
    description: 'Lightweight aluminum roofing panels'
  },
  {
    name: 'Metal Roofing (Steel)',
    category: 'Roofing',
    weightPerSqFt: 2.0,
    defaultCostPerTon: 65,
    description: 'Standard steel roofing panels'
  },
  {
    name: 'Metal Roofing (Standing Seam)',
    category: 'Roofing',
    weightPerSqFt: 2.6,
    defaultCostPerTon: 65,
    description: 'Heavy-duty standing seam metal roof'
  },
  {
    name: 'Slate Roofing (Standard)',
    category: 'Roofing',
    weightPerSqFt: 13.0,
    defaultCostPerTon: 65,
    description: 'Natural slate roofing material'
  },
  {
    name: 'Slate Roofing (Heavy)',
    category: 'Roofing',
    weightPerSqFt: 19.5,
    defaultCostPerTon: 65,
    description: 'Thick natural slate roofing'
  },
  {
    name: 'Wood Shakes/Shingles',
    category: 'Roofing',
    weightPerSqFt: 3.9,
    defaultCostPerTon: 65,
    description: 'Cedar or wood roofing shingles'
  },
  {
    name: 'TPO Roofing Membrane',
    category: 'Roofing',
    weightPerSqFt: 0.7,
    defaultCostPerTon: 65,
    description: 'Single-ply TPO rubber roofing'
  },
  {
    name: 'EPDM Roofing Membrane',
    category: 'Roofing',
    weightPerSqFt: 0.8,
    defaultCostPerTon: 65,
    description: 'Single-ply EPDM rubber roofing'
  },
  {
    name: 'Built-Up Roofing (3-Ply)',
    category: 'Roofing',
    weightPerSqFt: 3.2,
    defaultCostPerTon: 65,
    description: '3-ply built-up roofing system'
  },
  {
    name: 'Built-Up Roofing (5-Ply)',
    category: 'Roofing',
    weightPerSqFt: 5.2,
    defaultCostPerTon: 65,
    description: '5-ply built-up roofing system'
  },
  
  // === INSULATION ===
  {
    name: 'Fiberglass Batt Insulation R-11 (3.5")',
    category: 'Insulation',
    weightPerSqFt: 0.5,
    defaultCostPerTon: 45,
    description: 'Standard wall insulation for 2x4 walls'
  },
  {
    name: 'Fiberglass Batt Insulation R-13 (3.5")',
    category: 'Insulation',
    weightPerSqFt: 0.7,
    defaultCostPerTon: 45,
    description: 'High-density wall insulation for 2x4 walls'
  },
  {
    name: 'Fiberglass Batt Insulation R-19 (6.25")',
    category: 'Insulation',
    weightPerSqFt: 0.8,
    defaultCostPerTon: 45,
    description: 'Standard wall insulation for 2x6 walls'
  },
  {
    name: 'Fiberglass Batt Insulation R-21 (5.5")',
    category: 'Insulation',
    weightPerSqFt: 0.9,
    defaultCostPerTon: 45,
    description: 'High-density insulation for 2x6 walls'
  },
  {
    name: 'Fiberglass Batt Insulation R-30 (9.5")',
    category: 'Insulation',
    weightPerSqFt: 1.0,
    defaultCostPerTon: 45,
    description: 'Ceiling/attic insulation'
  },
  {
    name: 'Fiberglass Batt Insulation R-38 (12")',
    category: 'Insulation',
    weightPerSqFt: 1.3,
    defaultCostPerTon: 45,
    description: 'Heavy ceiling/attic insulation'
  },
  {
    name: 'Spray Foam Insulation (1")',
    category: 'Insulation',
    weightPerSqFt: 0.3,
    defaultCostPerTon: 45,
    description: 'Closed-cell spray foam per inch'
  },
  {
    name: 'Spray Foam Insulation (2")',
    category: 'Insulation',
    weightPerSqFt: 0.5,
    defaultCostPerTon: 45,
    description: 'Closed-cell spray foam 2 inches'
  },
  {
    name: 'Spray Foam Insulation (3")',
    category: 'Insulation',
    weightPerSqFt: 0.8,
    defaultCostPerTon: 45,
    description: 'Closed-cell spray foam 3 inches'
  },
  {
    name: 'Rigid Foam Board Insulation (1")',
    category: 'Insulation',
    weightPerSqFt: 0.4,
    defaultCostPerTon: 45,
    description: 'Rigid foam insulation board 1 inch'
  },
  {
    name: 'Rigid Foam Board Insulation (2")',
    category: 'Insulation',
    weightPerSqFt: 0.8,
    defaultCostPerTon: 45,
    description: 'Rigid foam insulation board 2 inches'
  },
  {
    name: 'Cellulose Blown-In Insulation (per inch)',
    category: 'Insulation',
    weightPerSqFt: 0.2,
    defaultCostPerTon: 45,
    description: 'Loose-fill cellulose insulation per inch depth'
  },
  {
    name: 'Mineral Wool Insulation R-15 (3.5")',
    category: 'Insulation',
    weightPerSqFt: 1.6,
    defaultCostPerTon: 45,
    description: 'Rock wool/mineral wool for 2x4 walls'
  },
  {
    name: 'Mineral Wool Insulation R-23 (5.5")',
    category: 'Insulation',
    weightPerSqFt: 2.3,
    defaultCostPerTon: 45,
    description: 'Rock wool/mineral wool for 2x6 walls'
  },
  
  // === WINDOWS ===
  {
    name: 'Single Pane Window (Standard)',
    category: 'Windows',
    weightPerSqFt: 3.9,
    defaultCostPerTon: 65,
    description: 'Basic single pane window with frame'
  },
  {
    name: 'Double Pane Window (Standard)',
    category: 'Windows',
    weightPerSqFt: 5.9,
    defaultCostPerTon: 65,
    description: 'Double pane insulated window'
  },
  {
    name: 'Double Pane Window (Low-E)',
    category: 'Windows',
    weightPerSqFt: 6.5,
    defaultCostPerTon: 65,
    description: 'Energy-efficient double pane window'
  },
  {
    name: 'Triple Pane Window',
    category: 'Windows',
    weightPerSqFt: 8.5,
    defaultCostPerTon: 65,
    description: 'High-efficiency triple pane window'
  },
  {
    name: 'Picture Window (Large)',
    category: 'Windows',
    weightPerSqFt: 7.2,
    defaultCostPerTon: 65,
    description: 'Large fixed picture window'
  },
  {
    name: 'Vinyl Window Frame',
    category: 'Windows',
    weightPerSqFt: 5.2,
    defaultCostPerTon: 65,
    description: 'Standard vinyl frame window'
  },
  {
    name: 'Wood Window Frame',
    category: 'Windows',
    weightPerSqFt: 7.2,
    defaultCostPerTon: 65,
    description: 'Solid wood frame window'
  },
  {
    name: 'Aluminum Window Frame',
    category: 'Windows',
    weightPerSqFt: 5.9,
    defaultCostPerTon: 65,
    description: 'Aluminum frame window'
  },
  {
    name: 'Fiberglass Window Frame',
    category: 'Windows',
    weightPerSqFt: 6.5,
    defaultCostPerTon: 65,
    description: 'Durable fiberglass frame window'
  },
  
  // === DOORS ===
  {
    name: 'Hollow Core Interior Door',
    category: 'Doors',
    weightPerSqFt: 2.0,
    defaultCostPerTon: 65,
    description: 'Lightweight hollow core door'
  },
  {
    name: 'Solid Core Interior Door',
    category: 'Doors',
    weightPerSqFt: 3.9,
    defaultCostPerTon: 65,
    description: 'Heavy solid core interior door'
  },
  {
    name: 'Solid Wood Door (Pine)',
    category: 'Doors',
    weightPerSqFt: 4.5,
    defaultCostPerTon: 65,
    description: 'Solid pine wood door'
  },
  {
    name: 'Solid Wood Door (Oak)',
    category: 'Doors',
    weightPerSqFt: 5.9,
    defaultCostPerTon: 65,
    description: 'Solid oak hardwood door'
  },
  {
    name: 'Solid Wood Door (Mahogany)',
    category: 'Doors',
    weightPerSqFt: 6.5,
    defaultCostPerTon: 65,
    description: 'Premium solid mahogany door'
  },
  {
    name: 'Steel Entry Door (Standard)',
    category: 'Doors',
    weightPerSqFt: 7.2,
    defaultCostPerTon: 65,
    description: 'Standard steel exterior entry door'
  },
  {
    name: 'Steel Entry Door (Insulated)',
    category: 'Doors',
    weightPerSqFt: 8.5,
    defaultCostPerTon: 65,
    description: 'Insulated steel entry door'
  },
  {
    name: 'Fiberglass Entry Door',
    category: 'Doors',
    weightPerSqFt: 5.9,
    defaultCostPerTon: 65,
    description: 'Fiberglass exterior entry door'
  },
  {
    name: 'French Door (Wood)',
    category: 'Doors',
    weightPerSqFt: 6.5,
    defaultCostPerTon: 65,
    description: 'Wood french door with glass panes'
  },
  {
    name: 'Sliding Glass Door',
    category: 'Doors',
    weightPerSqFt: 7.8,
    defaultCostPerTon: 65,
    description: 'Sliding patio glass door'
  },
  {
    name: 'Garage Door (Single Layer Steel)',
    category: 'Doors',
    weightPerSqFt: 2.0,
    defaultCostPerTon: 65,
    description: 'Single layer steel garage door'
  },
  {
    name: 'Garage Door (Double Layer Insulated)',
    category: 'Doors',
    weightPerSqFt: 3.2,
    defaultCostPerTon: 65,
    description: 'Insulated double layer garage door'
  },
  {
    name: 'Garage Door (Triple Layer Insulated)',
    category: 'Doors',
    weightPerSqFt: 4.5,
    defaultCostPerTon: 65,
    description: 'Heavy insulated triple layer garage door'
  },
  
  // === STRUCTURAL ===
  {
    name: 'Plywood Sheathing (1/4")',
    category: 'Structural',
    weightPerSqFt: 0.9,
    defaultCostPerTon: 65,
    description: 'Thin plywood sheathing'
  },
  {
    name: 'Plywood Sheathing (3/8")',
    category: 'Structural',
    weightPerSqFt: 1.4,
    defaultCostPerTon: 65,
    description: 'Light plywood sheathing'
  },
  {
    name: 'Plywood Sheathing (1/2")',
    category: 'Structural',
    weightPerSqFt: 2.0,
    defaultCostPerTon: 65,
    description: 'Standard plywood roof or wall sheathing'
  },
  {
    name: 'Plywood Sheathing (5/8")',
    category: 'Structural',
    weightPerSqFt: 2.3,
    defaultCostPerTon: 65,
    description: 'Thick plywood sheathing'
  },
  {
    name: 'Plywood Sheathing (3/4")',
    category: 'Structural',
    weightPerSqFt: 3.0,
    defaultCostPerTon: 65,
    description: 'Heavy plywood for subflooring'
  },
  {
    name: 'Plywood Sheathing (1")',
    category: 'Structural',
    weightPerSqFt: 3.9,
    defaultCostPerTon: 65,
    description: 'Extra thick plywood'
  },
  {
    name: 'OSB Sheathing (7/16")',
    category: 'Structural',
    weightPerSqFt: 1.8,
    defaultCostPerTon: 65,
    description: 'Oriented strand board sheathing'
  },
  {
    name: 'OSB Sheathing (1/2")',
    category: 'Structural',
    weightPerSqFt: 2.1,
    defaultCostPerTon: 65,
    description: 'Standard OSB sheathing'
  },
  {
    name: 'OSB Sheathing (5/8")',
    category: 'Structural',
    weightPerSqFt: 2.6,
    defaultCostPerTon: 65,
    description: 'Thick OSB sheathing'
  },
  {
    name: 'OSB Sheathing (3/4")',
    category: 'Structural',
    weightPerSqFt: 2.9,
    defaultCostPerTon: 65,
    description: 'Heavy OSB for subflooring'
  },
  {
    name: 'OSB Sheathing (1")',
    category: 'Structural',
    weightPerSqFt: 3.6,
    defaultCostPerTon: 65,
    description: 'Extra thick OSB'
  }
];

// VOLUME-BASED MATERIALS (Cubic Yards to Tons)
export const bulkMaterialDatabase = [
  // === SOIL & DIRT ===
  {
    name: 'Topsoil (Dry)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 1.1,
    description: 'Dry topsoil for landscaping'
  },
  {
    name: 'Topsoil (Moist)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 1.3,
    description: 'Moist topsoil for gardens'
  },
  {
    name: 'Topsoil (Wet)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 1.5,
    description: 'Wet saturated topsoil'
  },
  {
    name: 'Fill Dirt (Dry)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 1.4,
    description: 'Dry fill dirt for grading'
  },
  {
    name: 'Fill Dirt (Wet)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 1.7,
    description: 'Wet fill dirt'
  },
  {
    name: 'Clay (Dry)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 1.6,
    description: 'Dry clay soil'
  },
  {
    name: 'Clay (Wet)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 1.8,
    description: 'Wet clay soil'
  },
  {
    name: 'Potting Soil',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 0.4,
    description: 'Lightweight potting mix'
  },
  {
    name: 'Compost',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 0.5,
    description: 'Organic compost material'
  },
  {
    name: 'Mulch (Bark)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 0.3,
    description: 'Bark mulch for landscaping'
  },
  {
    name: 'Mulch (Wood Chips)',
    category: 'Soil & Dirt',
    tonsPerCubicYard: 0.4,
    description: 'Wood chip mulch'
  },
  
  // === SAND ===
  {
    name: 'Sand (Dry)',
    category: 'Sand',
    tonsPerCubicYard: 1.3,
    description: 'Dry construction sand'
  },
  {
    name: 'Sand (Damp)',
    category: 'Sand',
    tonsPerCubicYard: 1.5,
    description: 'Damp sand'
  },
  {
    name: 'Sand (Wet)',
    category: 'Sand',
    tonsPerCubicYard: 1.7,
    description: 'Wet saturated sand'
  },
  {
    name: 'Mason Sand',
    category: 'Sand',
    tonsPerCubicYard: 1.4,
    description: 'Fine sand for masonry work'
  },
  {
    name: 'Play Sand',
    category: 'Sand',
    tonsPerCubicYard: 1.3,
    description: 'Clean play sand for sandboxes'
  },
  {
    name: 'Beach Sand',
    category: 'Sand',
    tonsPerCubicYard: 1.5,
    description: 'Natural beach sand'
  },
  {
    name: 'Concrete Sand',
    category: 'Sand',
    tonsPerCubicYard: 1.4,
    description: 'Coarse sand for concrete mix'
  },
  
  // === GRAVEL & STONE ===
  {
    name: 'Gravel (1/4" - 2")',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.4,
    description: 'Small to medium gravel'
  },
  {
    name: 'Pea Gravel',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.3,
    description: 'Small rounded pea gravel'
  },
  {
    name: 'Crushed Stone (#57)',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.5,
    description: 'Common crushed stone'
  },
  {
    name: 'Crushed Stone (3/4")',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.5,
    description: '3/4 inch crushed stone'
  },
  {
    name: 'Crushed Granite',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.5,
    description: 'Decorative crushed granite'
  },
  {
    name: 'Limestone (Crushed)',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.5,
    description: 'Crushed limestone base'
  },
  {
    name: 'River Rock (1" - 3")',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.5,
    description: 'Smooth river rock'
  },
  {
    name: 'River Rock (3" - 6")',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.6,
    description: 'Large river rock'
  },
  {
    name: 'Lava Rock',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 0.7,
    description: 'Lightweight volcanic rock'
  },
  {
    name: 'Decorative Stone',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.5,
    description: 'Decorative landscape stone'
  },
  {
    name: 'Marble Chips',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.4,
    description: 'White marble chips'
  },
  {
    name: 'Slate Chips',
    category: 'Gravel & Stone',
    tonsPerCubicYard: 1.5,
    description: 'Decorative slate chips'
  },
  
  // === BASE MATERIALS ===
  {
    name: 'Crushed Concrete',
    category: 'Base Materials',
    tonsPerCubicYard: 1.4,
    description: 'Recycled crushed concrete'
  },
  {
    name: 'Crushed Asphalt',
    category: 'Base Materials',
    tonsPerCubicYard: 1.2,
    description: 'Recycled crushed asphalt'
  },
  {
    name: 'Caliche',
    category: 'Base Materials',
    tonsPerCubicYard: 1.5,
    description: 'Hardpan caliche base material'
  },
  {
    name: 'Road Base',
    category: 'Base Materials',
    tonsPerCubicYard: 1.4,
    description: 'Compacted road base material'
  },
  {
    name: 'Decomposed Granite (DG)',
    category: 'Base Materials',
    tonsPerCubicYard: 1.4,
    description: 'Decomposed granite base'
  },
  {
    name: 'Class 5 Aggregate',
    category: 'Base Materials',
    tonsPerCubicYard: 1.3,
    description: 'Class 5 road base aggregate'
  },
  
  // === SPECIALTY MATERIALS ===
  {
    name: 'Rip Rap (Small)',
    category: 'Specialty',
    tonsPerCubicYard: 1.4,
    description: 'Small erosion control rock'
  },
  {
    name: 'Rip Rap (Large)',
    category: 'Specialty',
    tonsPerCubicYard: 1.6,
    description: 'Large erosion control rock'
  },
  {
    name: 'Drain Rock',
    category: 'Specialty',
    tonsPerCubicYard: 1.4,
    description: 'Drainage rock aggregate'
  },
  {
    name: 'Bedding Sand',
    category: 'Specialty',
    tonsPerCubicYard: 1.4,
    description: 'Sand for paver bedding'
  },
  {
    name: 'Stone Dust',
    category: 'Specialty',
    tonsPerCubicYard: 1.5,
    description: 'Fine stone dust screenings'
  }
];

// OIL FIELD PIPING (Linear Feet to Pounds + Fluid Gallons)
// Weight includes pipe material + fluid content when full
export const oilFieldPipingDatabase = [
  // === STANDARD STEEL PIPE (SCH 40) ===
  {
    name: '2" Steel Pipe (SCH 40)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 3.65,
    fluidCapacityGallons: 0.17,
    totalWeightPerFt: 5.07, // pipe + fluid (assuming crude oil ~7 lbs/gal)
    description: 'Demolished 2" schedule 40 steel pipe with oil/fluid'
  },
  {
    name: '3" Steel Pipe (SCH 40)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 7.58,
    fluidCapacityGallons: 0.38,
    totalWeightPerFt: 10.24,
    description: 'Demolished 3" schedule 40 steel pipe with oil/fluid'
  },
  {
    name: '4" Steel Pipe (SCH 40)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 10.79,
    fluidCapacityGallons: 0.66,
    totalWeightPerFt: 15.41,
    description: 'Demolished 4" schedule 40 steel pipe with oil/fluid'
  },
  {
    name: '6" Steel Pipe (SCH 40)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 18.97,
    fluidCapacityGallons: 1.50,
    totalWeightPerFt: 29.47,
    description: 'Demolished 6" schedule 40 steel pipe with oil/fluid'
  },
  {
    name: '8" Steel Pipe (SCH 40)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 28.55,
    fluidCapacityGallons: 2.66,
    totalWeightPerFt: 47.17,
    description: 'Demolished 8" schedule 40 steel pipe with oil/fluid'
  },
  {
    name: '10" Steel Pipe (SCH 40)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 40.48,
    fluidCapacityGallons: 4.15,
    totalWeightPerFt: 69.53,
    description: 'Demolished 10" schedule 40 steel pipe with oil/fluid'
  },
  {
    name: '12" Steel Pipe (SCH 40)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 49.56,
    fluidCapacityGallons: 5.97,
    totalWeightPerFt: 91.35,
    description: 'Demolished 12" schedule 40 steel pipe with oil/fluid'
  },
  
  // === API 5L PIPELINE (Heavier wall) ===
  {
    name: '16" API 5L Pipeline (X52)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 82.77,
    fluidCapacityGallons: 10.61,
    totalWeightPerFt: 157.04,
    description: 'Demolished 16" API pipeline with crude oil'
  },
  {
    name: '20" API 5L Pipeline (X52)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 107.50,
    fluidCapacityGallons: 16.58,
    totalWeightPerFt: 223.56,
    description: 'Demolished 20" API pipeline with crude oil'
  },
  {
    name: '24" API 5L Pipeline (X52)',
    category: 'Oil Field Piping',
    weightPerLinearFt: 141.62,
    fluidCapacityGallons: 23.87,
    totalWeightPerFt: 308.71,
    description: 'Demolished 24" API pipeline with crude oil'
  }
];

// OIL FIELD STORAGE TANKS (Total Weight Per Tank)
// Includes tank structure, demolition debris, and residual contents
export const oilFieldTanksDatabase = [
  {
    name: '100 BBL Horizontal Storage Tank',
    category: 'Oil Field Tanks',
    capacity: '100 BBL (4,200 gal)',
    weightPerTank: 8500,
    description: 'Demolished 100 barrel horizontal tank (empty tank weight ~4,000 lbs + debris)'
  },
  {
    name: '210 BBL Vertical Storage Tank',
    category: 'Oil Field Tanks',
    capacity: '210 BBL (8,820 gal)',
    weightPerTank: 15000,
    description: 'Demolished 210 barrel vertical tank with residual oil'
  },
  {
    name: '400 BBL Production Tank',
    category: 'Oil Field Tanks',
    capacity: '400 BBL (16,800 gal)',
    weightPerTank: 25000,
    description: 'Demolished 400 barrel production tank'
  },
  {
    name: '500 BBL Vertical Storage Tank',
    category: 'Oil Field Tanks',
    capacity: '500 BBL (21,000 gal)',
    weightPerTank: 32000,
    description: 'Demolished 500 barrel vertical storage tank'
  },
  {
    name: '750 BBL Field Storage Tank',
    category: 'Oil Field Tanks',
    capacity: '750 BBL (31,500 gal)',
    weightPerTank: 42000,
    description: 'Demolished 750 barrel field storage tank with fittings'
  },
  {
    name: '1000 BBL Large Storage Tank',
    category: 'Oil Field Tanks',
    capacity: '1000 BBL (42,000 gal)',
    weightPerTank: 55000,
    description: 'Demolished 1000 barrel large storage tank'
  },
  {
    name: '1500 BBL Central Tank Battery',
    category: 'Oil Field Tanks',
    capacity: '1500 BBL (63,000 gal)',
    weightPerTank: 75000,
    description: 'Demolished 1500 barrel central tank battery unit'
  },
  {
    name: '2000 BBL Lease Storage Tank',
    category: 'Oil Field Tanks',
    capacity: '2000 BBL (84,000 gal)',
    weightPerTank: 95000,
    description: 'Demolished 2000 barrel lease storage tank with platform'
  },
  {
    name: '500 Gallon Skid-Mounted Tank',
    category: 'Oil Field Tanks',
    capacity: '500 gal',
    weightPerTank: 2500,
    description: 'Demolished 500 gallon portable skid tank'
  },
  {
    name: '1000 Gallon Fuel Storage Tank',
    category: 'Oil Field Tanks',
    capacity: '1000 gal',
    weightPerTank: 4200,
    description: 'Demolished 1000 gallon diesel/fuel storage tank'
  }
];